"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withQueryParams;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireDefault(require("query-string"));

var _reactDisplayName = _interopRequireDefault(require("react-display-name"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function withQueryParams() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      keys = _ref.keys,
      _ref$stripUnknownKeys = _ref.stripUnknownKeys,
      stripUnknownKeys = _ref$stripUnknownKeys === void 0 ? false : _ref$stripUnknownKeys,
      queryStringOptions = _ref.queryStringOptions;

  if (keys && stripUnknownKeys) {
    (0, _utils.assert)(Object.keys(keys).length > 0, 'at least one query param key must be configured');
  }

  if (keys) {
    Object.keys(keys).forEach(function (key) {
      (0, _utils.assert)(keys[key].validate, "Missing validate function for key ".concat(key));
      (0, _utils.assert)(typeof keys[key].validate === 'function', "'validate' for ".concat(key, " must be a function"));
    });
  }

  var QUERYPARAMS_OPTIONS = _objectSpread({
    arrayFormat: 'none'
  }, queryStringOptions);

  return function (Wrapped) {
    var WithQueryParams =
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(WithQueryParams, _PureComponent);

      function WithQueryParams() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, WithQueryParams);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithQueryParams)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "setQueryParams", function (obj) {
          var _this$props = _this.props,
              location = _this$props.location,
              history = _this$props.history;
          var to = history.createHref({
            pathname: location.pathname,
            search: _queryString.default.stringify(_objectSpread({}, _queryString.default.parse(location.search, QUERYPARAMS_OPTIONS), {}, obj), QUERYPARAMS_OPTIONS)
          });
          history.push(to);
        });

        return _this;
      }

      _createClass(WithQueryParams, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var location = this.props.location;

          var queryParams = _queryString.default.parse(location.search, QUERYPARAMS_OPTIONS);

          var newQueryParams = keys ? Object.keys(keys).reduce(function (acc, paramName) {
            var defaultConf = keys[paramName].default;
            var defaultValue = typeof defaultConf === 'function' ? defaultConf(queryParams[paramName], _this2.props) : defaultConf;
            return _objectSpread({}, acc, _defineProperty({}, paramName, keys[paramName].validate(queryParams[paramName], _this2.props) ? queryParams[paramName] : defaultValue));
          }, {}) : queryParams;
          var allParams = stripUnknownKeys ? newQueryParams : _objectSpread({}, queryParams, {}, newQueryParams);

          var searchString = _queryString.default.stringify(allParams, QUERYPARAMS_OPTIONS);

          if (location.search.replace('?', '') !== searchString) {
            return _react.default.createElement(_reactRouterDom.Redirect, {
              to: {
                pathname: location.pathname,
                search: searchString
              }
            });
          }

          var wrappedProps = {
            location: location,
            setQueryParams: this.setQueryParams,
            queryParams: allParams
          };
          return _react.default.createElement(Wrapped, _extends({}, this.props, wrappedProps));
        }
      }]);

      return WithQueryParams;
    }(_react.PureComponent);

    WithQueryParams.displayName = "withQueryParams(".concat((0, _reactDisplayName.default)(Wrapped), ")");
    WithQueryParams.propTypes = {
      location: _propTypes.default.shape({
        search: _propTypes.default.string,
        pathname: _propTypes.default.string
      }).isRequired,
      history: _propTypes.default.shape({
        push: _propTypes.default.func.isRequired,
        createHref: _propTypes.default.func.isRequired
      }).isRequired
    };
    return (0, _reactRouterDom.withRouter)(WithQueryParams);
  };
}